/**
 * Get Store Details Use Case
 * حالة الاستخدام لجلب تفاصيل المتجر
 */

import {StoreRepository} from '../repository/StoreRepository';
import {Store} from '../models/store.model';

export class GetStoreDetailsUseCase {
  constructor (private storeRepository: StoreRepository) {}

  /**
   * جلب تفاصيل المتجر
   */
  async execute (storeId: string): Promise<Store> {
    if (!storeId) {
      throw new Error('Store ID is required');
    }

    return await this.storeRepository.getById(storeId);
  }
}
